import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import "flag-icons/css/flag-icons.min.css";

import "./index.css";
import App from "./App";
import Backdrop from "./components/UI/Backdrop";

// const loadingMarkup = <Modal><h3>Loading...</h3></Modal>;
const loadingMarkup = <Backdrop />

ReactDOM.render(
  <Suspense fallback={loadingMarkup}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Suspense>,
  document.getElementById("root")
);
